import React, { Component } from 'react'
import { translation } from '../../../utils/helpers'
import { renderFullDate, getWeekDay } from '../../../utils/time'

import './notificationItem.scss'

class NotificationItem extends Component {
  render () {
    const { data } = this.props
    return (
      <div className='notification-item'>
        <div className={'notification-item__content read'}>
          <div className='h2-fz h2-color'>{translation(data.TitleDictionaryKey)}</div>
          <time className='color-wrap fz-wrap'>{getWeekDay(data.CreatedDate)}, {renderFullDate(data.CreatedDate)}</time>
          <p className='color-wrap fz-wrap'>{data.Contents}</p>
        </div>
      </div>
    )
  }
}
export default NotificationItem



// WEBPACK FOOTER //
// ./src/app/pages/CarOwnerPortal/components/notificationItem.js